module.exports = __webpack_public_path__ + "assets/870d4d9de0d0a4e2beea65ffdd750496.png";